import { render } from "./Agreement.vue?vue&type=template&id=032da736&scoped=true"
const script = {}

import "./Agreement.vue?vue&type=style&index=0&id=032da736&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20221128.131745/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032da736"]])

export default __exports__